<form class="change-email-dialog" [formGroup]="changeEmailFG" (ngSubmit)="submit()">
    <h2>Cambiar email</h2>
    <span>Esto cambiará el email del usuario {{ data.email }} y enviará un correo al email ingresado para configurar su nueva contraseña, el usuario quedará deshabilitado hasta que se configure la nueva contraseña.</span>
    <mat-form-field class="garantor-form-field" appearance="outline">
        <mat-label>Ingrese el nuevo email</mat-label>
        <input matInput formControlName="email">
        <mat-error *ngIf="changeEmailFG.controls.email.hasError('required')">
            Por favor ingrese un email
        </mat-error>
        <mat-error *ngIf="changeEmailFG.controls.email.hasError('email')">
            Ingrese un email válido
        </mat-error>
    </mat-form-field>
    <mat-form-field class="garantor-form-field" appearance="outline">
        <mat-label>Confirme el nuevo email</mat-label>
        <input matInput formControlName="confirm">
        <mat-error *ngIf="changeEmailFG.controls.confirm.hasError('required')">
            Vuelva a ingresar el email
        </mat-error>
        <mat-error *ngIf="changeEmailFG.controls.confirm.hasError('notEquals')">
            Los emails ingresados no son iguales
        </mat-error>
    </mat-form-field>
    <div class="buttons">
        <button mat-button color="accent" class="garantor-button mini" type="button" (click)="cancel()">Cancelar</button>
        <button mat-raised-button color="primary" class="garantor-button mini">Cambiar email</button>
    </div>
</form>
